import { BasemapOptions } from "../../../interfaces/config";
// @ts-ignore
import aerial2026Thumbnail from "./thumbnails/2026.png";
// @ts-ignore
import aerial2025Thumbnail from "./thumbnails/2025.png";
// @ts-ignore
import aerial2022Thumbnail from "./thumbnails/2022.png";
// @ts-ignore
import aerial2021Thumbnail from "./thumbnails/2021.png";
// @ts-ignore
import aerial2017Thumbnail from "./thumbnails/2017.png";
// @ts-ignore
import aerial2015Thumbnail from "./thumbnails/2015.png";
// @ts-ignore
import aerial2014Thumbnail from "./thumbnails/2014.png";
// @ts-ignore
import aerial2013Thumbnail from "./thumbnails/2013.png";
// @ts-ignore
import aerial2012Thumbnail from "./thumbnails/2012.png";
// @ts-ignore
import aerial2011Thumbnail from "./thumbnails/2011.png";
// @ts-ignore
import aerial2010Thumbnail from "./thumbnails/2010.png";
// @ts-ignore
import aerial2009Thumbnail from "./thumbnails/2009.png";
// @ts-ignore
import aerial2008Thumbnail from "./thumbnails/2008.png";
// @ts-ignore
import aerial2005Thumbnail from "./thumbnails/2005.png";
// @ts-ignore
import aerial1980Thumbnail from "./thumbnails/1980.png";
// @ts-ignore
import aerial1967Thumbnail from "./thumbnails/1967.png";
// @ts-ignore
import aerial1954Thumbnail from "./thumbnails/1954.png";
// @ts-ignore
import aerial1939Thumbnail from "./thumbnails/1939.png";

const imageryServerBaseUrl =
  "https://www.mchenrycountygis.org/Imagery/rest/services/";
const mapServerBaseUrl =
  "https://www.mchenrycountygis.org/arcgis/rest/services/";

const surroundingCountiesLayerUrl = `${mapServerBaseUrl}Surrounding_Counties/MapServer`;
const aerialOverlayDynLayerUrl = `${mapServerBaseUrl}aerialoverlaydyn/MapServer`;
const roadcenterlinesDynLayerUrl = `${mapServerBaseUrl}roadcenterlinesdyn/MapServer`;
// New aerial overlay layer w/o the parcel lines
const aerialOverlayLayerUrl = `${mapServerBaseUrl}aerialoverlay/MapServer`;

const config: BasemapOptions = {
  default: "2022_aerial",
  showBasemapSelector: false,
  basemaps: [
    {
      id: "2026_aerial",
      year: 2026,
      title: "2026 Aerial",
      thumbnail: aerial2026Thumbnail,
      basemapLayers: [
        {
          type: "imagery-tile",
          url: `${imageryServerBaseUrl}/2026aerials/ImageServer`,
        },
        surroundingCountiesLayerUrl,
        aerialOverlayLayerUrl,
      ],
      scaleBasemapLayers: [
        {
          type: "imagery",
          url: `${imageryServerBaseUrl}/2026aerialsdyn/ImageServer`,
        },
        surroundingCountiesLayerUrl,
        { type: "map-image", url: aerialOverlayDynLayerUrl },
        { type: "map-image", url: roadcenterlinesDynLayerUrl },
      ],
    },
    {
      id: "2025_aerial",
      year: 2025,
      title: "2025 Aerial",
      thumbnail: aerial2025Thumbnail,
      basemapLayers: [
        {
          type: "imagery-tile",
          url: `${imageryServerBaseUrl}/2025aerials/ImageServer`,
        },
        surroundingCountiesLayerUrl,
        aerialOverlayLayerUrl,
      ],
      scaleBasemapLayers: [
        {
          type: "imagery",
          url: `${imageryServerBaseUrl}/2025aerialsdyn/ImageServer`,
        },
        surroundingCountiesLayerUrl,
        { type: "map-image", url: aerialOverlayDynLayerUrl },
        { type: "map-image", url: roadcenterlinesDynLayerUrl },
      ],
    },
    {
      id: "2022_aerial",
      year: 2022,
      title: "2022 Aerial",
      thumbnail: aerial2022Thumbnail,
      basemapLayers: [
        {
          type: "imagery-tile",
          url: `${imageryServerBaseUrl}/2022aerials/ImageServer`,
        },
        surroundingCountiesLayerUrl,
        aerialOverlayLayerUrl,
      ],
      scaleBasemapLayers: [
        {
          type: "imagery",
          url: `${imageryServerBaseUrl}/2022aerialsdyn/ImageServer`,
        },
        surroundingCountiesLayerUrl,
        { type: "map-image", url: aerialOverlayDynLayerUrl },
        { type: "map-image", url: roadcenterlinesDynLayerUrl },
      ],
    },
    {
      id: "2021_aerial",
      year: 2021,
      title: "2021 Aerial",
      thumbnail: aerial2021Thumbnail,
      basemapLayers: [
        {
          type: "imagery-tile",
          url: `${imageryServerBaseUrl}/2021aerials/ImageServer`,
        },
        surroundingCountiesLayerUrl,
        aerialOverlayLayerUrl,
      ],
      scaleBasemapLayers: [
        {
          type: "imagery",
          url: `${imageryServerBaseUrl}/2021aerialsdyn/ImageServer`,
        },
        surroundingCountiesLayerUrl,
        { type: "map-image", url: aerialOverlayDynLayerUrl },
        { type: "map-image", url: roadcenterlinesDynLayerUrl },
      ],
    },
    {
      id: "2018_aerial",
      year: 2018,
      title: "2018 Aerial",
      thumbnail: aerial2017Thumbnail,
      basemapLayers: [
        {
          type: "imagery-tile",
          url: `${imageryServerBaseUrl}/2018aerials/ImageServer`,
        },
        surroundingCountiesLayerUrl,
        aerialOverlayLayerUrl,
      ],
      scaleBasemapLayers: [
        {
          type: "imagery",
          url: `${imageryServerBaseUrl}/2018aerialsdyn/ImageServer`,
        },
        surroundingCountiesLayerUrl,
        { type: "map-image", url: aerialOverlayDynLayerUrl },
        { type: "map-image", url: roadcenterlinesDynLayerUrl },
      ],
    },
    {
      id: "2017_aerial",
      year: 2017,
      title: "2017 Aerial",
      thumbnail: aerial2017Thumbnail,
      basemapLayers: [
        {
          type: "imagery-tile",
          url: `${imageryServerBaseUrl}/2017aerials/ImageServer`,
        },
        surroundingCountiesLayerUrl,
        aerialOverlayLayerUrl,
      ],
      scaleBasemapLayers: [
        {
          type: "imagery",
          url: `${imageryServerBaseUrl}/2017aerialsdyn/ImageServer`,
        },
        surroundingCountiesLayerUrl,
        { type: "map-image", url: aerialOverlayDynLayerUrl },
        { type: "map-image", url: roadcenterlinesDynLayerUrl },
      ],
    },
    {
      id: "2015_aerial",
      year: 2015,
      title: "2015 Aerial",
      thumbnail: aerial2015Thumbnail,
      basemapLayers: [
        {
          type: "imagery-tile",
          url: `${imageryServerBaseUrl}/2015aerials/ImageServer`,
        },
        surroundingCountiesLayerUrl,
        aerialOverlayLayerUrl,
      ],
      scaleBasemapLayers: [
        {
          type: "imagery",
          url: `${imageryServerBaseUrl}/2015aerialsdyn/ImageServer`,
        },
        surroundingCountiesLayerUrl,
        { type: "map-image", url: aerialOverlayDynLayerUrl },
        { type: "map-image", url: roadcenterlinesDynLayerUrl },
      ],
    },
    {
      id: "2014_aerial",
      year: 2014,
      title: "2014 Aerial",
      thumbnail: aerial2014Thumbnail,
      basemapLayers: [
        {
          type: "imagery-tile",
          url: `${imageryServerBaseUrl}/2014aerials/ImageServer`,
        },
        surroundingCountiesLayerUrl,
        aerialOverlayLayerUrl,
      ],
      scaleBasemapLayers: [
        {
          type: "imagery",
          url: `${imageryServerBaseUrl}/2014aerialsdyn/ImageServer`,
        },
        surroundingCountiesLayerUrl,
        { type: "map-image", url: aerialOverlayDynLayerUrl },
        { type: "map-image", url: roadcenterlinesDynLayerUrl },
      ],
    },
    {
      id: "2013_aerial",
      year: 2013,
      title: "2013 Aerial",
      thumbnail: aerial2013Thumbnail,
      basemapLayers: [
        {
          type: "imagery-tile",
          url: `${imageryServerBaseUrl}/2013aerials/ImageServer`,
        },
        surroundingCountiesLayerUrl,
        aerialOverlayLayerUrl,
      ],
      scaleBasemapLayers: [
        {
          type: "imagery",
          url: `${imageryServerBaseUrl}/2013aerialsdyn/ImageServer`,
        },
        surroundingCountiesLayerUrl,
        { type: "map-image", url: aerialOverlayDynLayerUrl },
        { type: "map-image", url: roadcenterlinesDynLayerUrl },
      ],
    },
    {
      id: "2012_aerial",
      year: 2012,
      title: "2012 Aerial",
      thumbnail: aerial2012Thumbnail,
      basemapLayers: [
        {
          type: "imagery-tile",
          url: `${imageryServerBaseUrl}/2012aerials/ImageServer`,
        },
        aerialOverlayLayerUrl,
      ],
      scaleBasemapLayers: [
        {
          type: "imagery",
          url: `${imageryServerBaseUrl}/2012aerialsdyn/ImageServer`,
        },
        { type: "map-image", url: aerialOverlayDynLayerUrl },
        { type: "map-image", url: roadcenterlinesDynLayerUrl },
      ],
    },
    {
      id: "2011_aerial",
      year: 2011,
      title: "2011 Aerial",
      thumbnail: aerial2011Thumbnail,
      basemapLayers: [
        {
          type: "imagery-tile",
          url: `${imageryServerBaseUrl}/2011aerials/ImageServer`,
        },
        aerialOverlayLayerUrl,
      ],
      scaleBasemapLayers: [
        {
          type: "imagery",
          url: `${imageryServerBaseUrl}/2011aerialsdyn/ImageServer`,
        },
        { type: "map-image", url: aerialOverlayDynLayerUrl },
        { type: "map-image", url: roadcenterlinesDynLayerUrl },
      ],
    },
    {
      id: "2010_aerial",
      year: 2010,
      title: "2010 Aerial",
      thumbnail: aerial2010Thumbnail,
      basemapLayers: [
        {
          type: "imagery-tile",
          url: `${imageryServerBaseUrl}/2010aerials/ImageServer`,
        },
        aerialOverlayLayerUrl,
      ],
      scaleBasemapLayers: [
        {
          type: "imagery",
          url: `${imageryServerBaseUrl}/2010aerialsdyn/ImageServer`,
        },
        { type: "map-image", url: aerialOverlayDynLayerUrl },
        { type: "map-image", url: roadcenterlinesDynLayerUrl },
      ],
    },
    {
      id: "2009_aerial",
      year: 2009,
      title: "2009 Aerial",
      thumbnail: aerial2009Thumbnail,
      basemapLayers: [
        {
          type: "imagery-tile",
          url: `${imageryServerBaseUrl}/2009aerials/ImageServer`,
        },
        aerialOverlayLayerUrl,
      ],
      scaleBasemapLayers: [
        {
          type: "imagery",
          url: `${imageryServerBaseUrl}/2009aerialsdyn/ImageServer`,
        },
        { type: "map-image", url: aerialOverlayDynLayerUrl },
        { type: "map-image", url: roadcenterlinesDynLayerUrl },
      ],
    },
    {
      id: "2008_aerial",
      year: 2008,
      title: "2008 Aerial",
      thumbnail: aerial2008Thumbnail,
      basemapLayers: [
        {
          type: "imagery-tile",
          url: `${imageryServerBaseUrl}/2008aerials/ImageServer`,
        },
        aerialOverlayLayerUrl,
      ],
      scaleBasemapLayers: [
        {
          type: "imagery",
          url: `${imageryServerBaseUrl}/2008aerialsdyn/ImageServer`,
        },
        { type: "map-image", url: aerialOverlayDynLayerUrl },
        { type: "map-image", url: roadcenterlinesDynLayerUrl },
      ],
    },
    {
      id: "2005_aerial",
      year: 2005,
      title: "2005 Aerial",
      thumbnail: aerial2005Thumbnail,
      basemapLayers: [
        {
          type: "imagery-tile",
          url: `${imageryServerBaseUrl}/2005aerials/ImageServer`,
        },
        aerialOverlayLayerUrl,
      ],
      scaleBasemapLayers: [
        {
          type: "imagery",
          url: `${imageryServerBaseUrl}/2005aerialsdyn/ImageServer`,
        },
        { type: "map-image", url: aerialOverlayDynLayerUrl },
        { type: "map-image", url: roadcenterlinesDynLayerUrl },
      ],
    },
    {
      id: "1980_aerial",
      year: 1980,
      title: "1980 Aerial",
      thumbnail: aerial1980Thumbnail,
      basemapLayers: [
        {
          type: "imagery-tile",
          url: `${imageryServerBaseUrl}/1980aerials/ImageServer`,
        },
        aerialOverlayLayerUrl,
      ],
      scaleBasemapLayers: [
        {
          type: "imagery",
          url: `${imageryServerBaseUrl}/1980aerialsdyn/ImageServer`,
        },
        { type: "map-image", url: aerialOverlayDynLayerUrl },
        { type: "map-image", url: roadcenterlinesDynLayerUrl },
      ],
    },
    {
      id: "1967_aerial",
      year: 1967,
      title: "1967 Aerial",
      thumbnail: aerial1967Thumbnail,
      basemapLayers: [
        {
          type: "imagery-tile",
          url: `${imageryServerBaseUrl}/1967aerials/ImageServer`,
        },
        aerialOverlayLayerUrl,
      ],
      scaleBasemapLayers: [
        {
          type: "imagery",
          url: `${imageryServerBaseUrl}/1967aerialsdyn/ImageServer`,
        },
        { type: "map-image", url: aerialOverlayDynLayerUrl },
        { type: "map-image", url: roadcenterlinesDynLayerUrl },
      ],
    },
    {
      id: "1954_aerial",
      year: 1954,
      title: "1954 Aerial",
      thumbnail: aerial1954Thumbnail,
      basemapLayers: [
        {
          type: "imagery-tile",
          url: `${imageryServerBaseUrl}/1954aerials/ImageServer`,
        },
        aerialOverlayLayerUrl,
      ],
      scaleBasemapLayers: [
        {
          type: "imagery",
          url: `${imageryServerBaseUrl}/1954aerialsdyn/ImageServer`,
        },
        { type: "map-image", url: aerialOverlayDynLayerUrl },
        { type: "map-image", url: roadcenterlinesDynLayerUrl },
      ],
    },
    {
      id: "1939_aerial",
      year: 1939,
      title: "1939 Aerial",
      thumbnail: aerial1939Thumbnail,
      basemapLayers: [
        {
          type: "imagery",
          url: `${imageryServerBaseUrl}/1939aerialsdyn/ImageServer`,
        },
        aerialOverlayLayerUrl,
      ],
      scaleBasemapLayers: [
        {
          type: "imagery",
          url: `${imageryServerBaseUrl}/1939aerialsdyn/ImageServer`,
        },
        { type: "map-image", url: aerialOverlayDynLayerUrl },
        { type: "map-image", url: roadcenterlinesDynLayerUrl },
      ],
    },
  ],
};

export default config;
